import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Onboarding from "./pages/Onboarding";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Sugar from "./pages/Sugar";
import BP from "./pages/BP";
import Weight from "./pages/Weight";
import Water from "./pages/Water";
import Sleep from "./pages/Sleep";
import Exercise from "./pages/Exercise";
import Medication from "./pages/Medication";
import AIChat from "./pages/AIChat";
import Profile from "./pages/Profile";
import More from "./pages/More";

function AppRouter() {
  const location = useLocation();
  // Detect Google OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute requireProfile={false}>
            <Onboarding />
          </ProtectedRoute>
        }
      />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/sugar" element={<Sugar />} />
        <Route path="/bp" element={<BP />} />
        <Route path="/weight" element={<Weight />} />
        <Route path="/water" element={<Water />} />
        <Route path="/sleep" element={<Sleep />} />
        <Route path="/exercise" element={<Exercise />} />
        <Route path="/medication" element={<Medication />} />
        <Route path="/assistant" element={<AIChat />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/more" element={<More />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
